import { inject, Injectable } from '@angular/core';
import {
  CreateHotToastRef,
  HotToastService,
  ToastOptions
} from '@ngneat/hot-toast';
import { Content } from '@ngneat/overview';

@Injectable()
export class ToastService {
  protected _toastService = inject(HotToastService);

  open<T = unknown>(options: {
    content: Content;
    type?: 'error' | 'success' | 'warning' | 'info' | 'show' | 'loading';
    config?: ToastOptions<T>;
  }): CreateHotToastRef<T> {
    const { type = 'success', config } = options;
    const { content } = options;

    const toastRef = this._toastService[type](content, config);
    return toastRef as CreateHotToastRef<T>;
  }
}
